import { Component, EventEmitter, input, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { typesApex } from '../models';
import ApexCharts from 'apexcharts';
import { formatear } from '../../elements/funciones/funcionesGenerales';
import { title } from 'process';
import { text } from 'stream/consumers';
import { IMG } from '../../services/imagen/png';
import { TranslateService } from '@ngx-translate/core';
import { messages } from '../../elements/funciones/mensajes';
import Swal from 'sweetalert2';
import { toPng } from 'html-to-image';

interface Titulos{
  titulo:string;
  subtitulo:string;
  nombreArch:string;
}

@Component({
  selector: 'app-graficador',
  templateUrl: './graficador.component.html',
  styleUrl: './graficador.component.css'
})

export class GraficadorComponent implements OnChanges{
  public types = typesApex;
  private options;
  private options_export;
  public chart;
  public chartAmp;
  private showLabel: number = 0;
  public tituloZona;
  public subTituloZona;
  private ancho = 460;

  
  @Input() etiquetas:boolean = false; //mostrar o ocultar etiquetas
  @Input() changeLabel:boolean = true; //bandera que cambia entre true y false para cambiar etiquetas
  @Input() data: any[]; // arreglo de datos a graficar la data se espera como un objeto que tiene un "name" y una "data", la data solo esta compuesta de los valores a gráficar
  @Input() labels: string[];// Son las etiquetas que tiene el eje x
  @Input() type: string; // tipo de grafica puede ser string directo o del catalago de typesApex de models
  @Input() colors: string[] = ['#004A97', '#68B4D6', '#82CC60', '#FFCB03', '#FC8A33', '#F74C58']; //colores a utilizar
  @Input() axisY: string[] = ['']; //nombres de los ejes Y
  @Input() axisX: string = ''; //nombres del eje X
  @Input() animations: boolean = true; 
  @Input() speedAnimations: number = 1200
  @Input() legend = {enabled: false, position: 'right'};
  @Input() zona: number; // numero de zona para identificador para no tener duplicidad de divs
  @Input() formatEtiquetas: boolean = false; // formato de las etiquetas a mostrar por ejemplo porcentaje o monto que representa true -> numero false -> porcentaje
  @Input() stackedAbsoluto: boolean = false; // en apiladas, apila los valores reales (el total puede pasar de 100) en lugar de normalizar cada barra al 100%
  @Input() porcentaje: boolean = false; // muestra % del total en vez del monto real (barras, líneas y áreas con el eje en %, dona/pie y mapa de calor). En cascada (WATERFALL) los valores ya son % y se muestran con el símbolo. En apilada con stackedAbsoluto, los valores ya son % (ver setApiladaPorcentaje)
  @Input() cascadaTotales: number[] = []; // en cascada (WATERFALL), posiciones de las barras que son un total: arrancan de 0 con su valor y reinician el acumulado; el resto son variaciones (+/-) sobre el acumulado
  @Input() comboLineaPorcentaje: boolean = false; // en combinada, muestra las etiquetas de todas las series a la vez; con formatEtiquetas la serie 0 (la línea) va como % y el resto como monto abreviado (M/Mil)
  @Input() altoEtiquetasX: number = 200; // en caso de requerir ajustar el alto maximo de las etiquetas del eje x
  @Input() setTwoLast: boolean = false; //Para el caso de graficas combinadas es obligatorio mandarlo en true 
  @Input() distributed: boolean = false;// En el caso de una grafica de barras permite poner un color diferente a cada barra
  @Input() rangoColores: any[] = [];// Rango de colores normalmente usado para cuando son gráficas combinadas
  @Input() maxLenghtRadar: number;// Maximo de letrs en las etiquetas del radar
  @Input() hetamapValor: boolean = false; // en heatmap, decide si la etiqueta muestra el NOMBRE de la cuenta o el VALOR (no confundir con porcentaje, que decide si el valor va en % o en monto real)
  @Input() sizeRadar: number = 100;// Modifica el tamaño de la gráfica de radar
  @Input() stroke: boolean = false; //Este parametro nos indica si en las graficas la primer serie tendra linea punteda
  @Input() lineaReferencia: number | null = null; // Si se indica, dibuja una línea horizontal de referencia (anotación eje Y)
  @Input() lineaReferenciaLabel: string = ''; // Texto de la etiqueta de la línea de referencia
  @Input() divisionesEjeX: number = 5; //Indica el numero de divisiones para el eje X 
  @Input() alinearYIzquierda: boolean = true; 
  @Input() agruparCategoriasExcedentes: boolean = false; //Poner en true en caso de querer mostrar los datos mas representativos 
  @Input() maxCategoriasVisibles: number = 8; //numero categorias visibles 
  @Input() etiquetaOtros: string = 'Otros'; // etiqueta que se mostrara para el resto de datos
  @Input() ordenCategorias: 'original' | 'ascendente' | 'descendente' = 'original'; //Ordena los datos a mostrar
  @Input() info: string = ''; //En caso de requirir una leyenda al pie de pagina por ejemplo info de click
  @Output() eventClick = new EventEmitter;
  private labelsGRafica: string[] = [];

  constructor(
    private translate: TranslateService,
  ){}
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['data'] && this.type !== this.types.TABLE && this.data.length !== 0){
      this.optionsGraphic();
    }else if(changes['etiquetas']){
      this.onOffLabels();
    }else if(changes['changeLabel']){
      this.changeLabels('add');
    }else if(changes['type']){
      this.optionsGraphic()
    }else if((changes['lineaReferencia'] || changes['lineaReferenciaLabel'] || changes['agruparCategoriasExcedentes'] || changes['maxCategoriasVisibles'] || changes['etiquetaOtros'] || changes['ordenCategorias']) && this.type !== this.types.TABLE && this.data && this.data.length !== 0){
      // Toggle de la línea de referencia: hay que reconstruir para pintar/quitar la anotación
      this.optionsGraphic();
    }
  }
  /* CReación de la tabla y de la gráfica */
  private optionsGraphic(){
    if(this.options !== undefined){
      this.chart.destroy();
    }
    var dataFormat = this.formatData();
    const datosResumidos = this.resumirCategoriasHorizontales(dataFormat, this.labels);
    dataFormat = datosResumidos.data;
    this.labelsGRafica = datosResumidos.labels;
    var {typeGraph, stacked, funnel}  = this.caracteristicas();

    var paddingleft = 0;
    switch(this.type){
      case typesApex.HEATMAP: 
        paddingleft = 0;
        break;
      case typesApex.BARHORIZONTAL:
      case typesApex.FUNNEL:
        paddingleft = -10;
        break;
      case typesApex.LINE:
      case typesApex.AREA:
        // Espacio extra para que la etiqueta del primer punto no choque con el eje Y
        paddingleft = 15;
        break;
      default:
        paddingleft = 0;
        break;
    }
    this.options = {
      series: dataFormat,
      chart: {
        width: "98%",
        height: this.info.length > 0 ? "90%" : "100%",
        type: typeGraph,
        stacked: stacked,
        stackType: stacked && !this.stackedAbsoluto ? "100%" : "0%",
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
        animations: {
          enabled: this.animations,
          speed: this.speedAnimations,
          easing: 'easeinout',
          animateGradually: {
            enabled: true,
            delay: 100
          },
          dynamicAnimation: {
            enabled: true,
            speed: 100
          }
        },
        events: {
          dataPointSelection: (event, chartContext, opts) => {
            var value;
            if(this.type === typesApex.HEATMAP){
              value = chartContext.opts.series[opts.seriesIndex].data[opts.dataPointIndex].y;
            }else if(this.type === typesApex.PIE || this.type === typesApex.DONUT){
              value = chartContext.opts.series[opts.dataPointIndex];
            }else{
              value = chartContext.opts.series[opts.seriesIndex].data[opts.dataPointIndex];
            }
            var data = {
              name: chartContext.opts.xaxis.categories[opts.dataPointIndex],
              value: value,
              serie: opts.seriesIndex,
              posValue: opts.dataPointIndex,
            }
            this.clickSeries(data)
          },
          mounted: (chartContext) => {
            if(this.legend.position === 'right'){
              this.agregarTooltipLeyenda(chartContext);
            }
          },
          updated: (chartContext) => {
            if(this.legend.position === 'right'){
              this.agregarTooltipLeyenda(chartContext);
            }
          }
        }
      },
      labels: this.labelsGRafica,
      colors: this.colors,
      grid: {
        show: this.type==='radar'?false:true,
        padding: {
          bottom: this.type === typesApex.RADAR ? -10 : 10,
          right: this.type === typesApex.HEATMAP || this.type === typesApex.RADAR ? 0 : 30,
          left: this.type === typesApex.RADAR ? -10 : paddingleft,
          top: this.type === typesApex.RADAR ? -10 : 0,
        }
      },
      markers: {
        size: 6,
        hover: {
          size: 6
        },
        fillOpacity: 1,
      },
      legend: {
        show: this.legend.enabled,
        position: this.legend.position,
        offsetX: -30,
        itemMargin: {
          horizontal: 10,
          vertical: 0
        },
        formatter: (seriesName) => this.legend.position === 'right' && seriesName.length > 22 ? seriesName.substring(0, 22) + '...' : seriesName
      },
      theme: {
        monochrome: {
          enabled: (this.type !== typesApex.PIE && this.type !== typesApex.DONUT) ? false : this.distributed,
          color: this.colors[0]
        }
      },
      dataLabels: {
        enabled: this.etiquetas,
        formatter: ( val, opts) => {
          if(!this.formatEtiquetas){
            if(this.type === typesApex.PIE || this.type === typesApex.DONUT){
              // val es el % que calcula ApexCharts; el monto real hay que sacarlo de la serie.
              const valor = this.porcentaje
                ? `${val.toFixed(1)}%`
                : this.formatearMontoAbreviado(opts.w.globals.series[opts.seriesIndex]);
              // Sin leyenda no hay otro lugar donde ver el nombre: la etiqueta lo lleva siempre
              return this.legend.enabled ? [valor] : [valor, `${opts.w.config.labels[opts.seriesIndex]}`];
            }else if(this.type === typesApex.HEATMAP){
              // La etiqueta siempre va, entre corchetes y más chica (ver reducirNombreHeatmap).
              // Se quita " años" de los rangos de edad.
              const nombreCuenta = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].x;
              const etiqueta = `[${`${nombreCuenta}`.replace(' años', '')}]`;
              if(this.porcentaje){
                const serieValores: number[] = opts.w.globals.series[opts.seriesIndex] ?? [];
                const tot = Number(serieValores.reduce((a, b) => a + Number(b), 0).toFixed(1));
                const valNum = Number(opts.value);
                const por = (valNum===0 || !tot || isNaN(tot))?0:Number((valNum*100/tot).toFixed(1));
                return [`${por}%`, etiqueta];
              }
              if(this.hetamapValor){
                return [`${opts.value}`];
              }
              // opts.value (no val) trae el dato real, igual que en porcentaje/hetamapValor.
              return [this.formatearMontoAbreviado(opts.value), etiqueta];
            }else if(this.type === typesApex.STACKED){
              return [`${val.toFixed(1)} %`];
            }else if(this.type === typesApex.RADAR){
              return `${val}`
            }else if(opts){
              const tot = Number(opts.w.config.series[opts.seriesIndex].data.reduce((a, b) => a + b, 0).toFixed(1));
              const por = (val===0 || tot===0)?0:Number((val*100/tot).toFixed(1))
                return [`${por} %`];
            }            
          }
          if(this.formatEtiquetas){
            // ApexCharts sigue llamando este formatter con val=undefined para series
            // ocultas desde la leyenda; sin este guard, tronaba y dejaba la gráfica
            // en un estado roto (afectando también a las demás series).
            if(val == null){
              return [''];
            }
            if(this.comboLineaPorcentaje){
              if(opts.seriesIndex === 0){
                return [`${val.toFixed(1)} %`];
              }
              return [this.formatearMontoAbreviado(val)];
            }
            if(val > 100){
              return formatear.formatearMoneda(val,false,',','.');
            }else{
              if(this.type === typesApex.STACKED || this.type === typesApex.STACKEDHORIZONTAL){
                return [`${val.toFixed(2)} %`];
              }
              return formatear.formatearMoneda(Number((val).toFixed(2)),true,',','.');
            }

          }
          return [''];
        },
        textAnchor: this.type !== typesApex.STACKED && this.type !== typesApex.STACKEDHORIZONTAL && this.type !== typesApex.HEATMAP ? 'start': 'middle',
        position: 'center',
        offsetX: 0,
        offsetY: this.type !== typesApex.STACKEDHORIZONTAL ? -5 : 0,
        style:{
          fontWeight: this.type === typesApex.HEATMAP && !this.porcentaje ? 500 : 400,
          fontFamily: 'Roboto',
          fontSize: this.type === typesApex.HEATMAP ? '20px' : '11px',
          colors: this.type === typesApex.HEATMAP ? ['#000000'] : []
        },
        dropShadow: {
          enabled: false,
        },
        background: {
          enabled: true,
          foreColor: '#000000',
          padding: 4,
          borderRadius: 2,
          borderWidth: 1,
          borderColor: '#000000',
          opacity: 0,
          dropShadow: {
            enabled: false,
          }
        },
      },
      stroke: {
        show: this.type !== typesApex.DONUT ? true : false,
        curve: 'smooth',
      },
      xaxis: {
        max: undefined,
        min: undefined,
        categories: this.labelsGRafica,
        tickAmount: this.esBarraHorizontal ? this.divisionesEjeX : undefined,
        labels: {
          maxHeight: this.altoEtiquetasX,
          maxWidth: 200,
          rotate: -90,
          trim: this.esBarraHorizontal?false:true,
          style: {
            fontSize: '12px',
          },
          formatter: (value) => {

            if(this.type !== typesApex.RADAR || !this.maxLenghtRadar) return value;

            return value.length > this.maxLenghtRadar
              ? value.substring(0, this.maxLenghtRadar) + '...'
              : value;
          }
        },
        tooltip:{
          enabled: false,
          theme: "dark",
        },
        title:{
          text: this.axisX,
          offsetY: 0,
          style:{fontWeight: 400, fontSize: '13px'}
        }
      },
      // Mapa de calor con una sola serie no pasa por setEjes(); sin esto, ApexCharts
      // reserva espacio para un eje Y aunque esté vacío y el mapa queda descentrado.
      yaxis: this.type === typesApex.HEATMAP ? { show: false } : {},
      tooltip: {
        enabled: true,
        shared: false,
        intersect: true,
         // Cambiar formato del valor
        y: {
          formatter: (val) => {
            if(val > 100){
              return formatear.formatearMoneda(val,false,',','.');
            }else{
              return formatear.formatearMoneda(Number((val).toFixed(2)),true,',','.');
            }            
          },
        },
        x: {
          formatter: (value, { dataPointIndex }) => {
            return this.labelsGRafica[dataPointIndex];
          }
        }
      }
    };
    this.options_export = {
      series: dataFormat,
      chart: {
        width: "98%",
        height: "100%",
        type: typeGraph,
        stacked: stacked,
        stackType: stacked && !this.stackedAbsoluto ? "100%" : "0%",
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
        animations: {
          enabled: this.animations,
          speed: this.speedAnimations,
          animateGradually: {
            enabled: true,
            delay: 100
          },
          dynamicAnimation: {
            enabled: true,
            speed: 100
          }
        },
        events: {
          dataPointSelection: (event, chartContext, opts) => {
            var value;
            if(this.type === typesApex.HEATMAP){
              value = chartContext.opts.series[opts.seriesIndex].data[opts.dataPointIndex].y;
            }else if(this.type === typesApex.PIE || this.type === typesApex.DONUT){
              value = chartContext.opts.series[opts.dataPointIndex];
            }else{
              value = chartContext.opts.series[opts.seriesIndex].data[opts.dataPointIndex];
            }
            var data = {
              name: chartContext.opts.xaxis.categories[opts.dataPointIndex],
              value: value,
              serie: opts.seriesIndex,
              posValue: opts.dataPointIndex,
            }
            this.clickSeries(data)
          },
          mounted: (chartContext) => {
            if(this.legend.position === 'right'){
              this.agregarTooltipLeyenda(chartContext);
            }
          },
          updated: (chartContext) => {
            if(this.legend.position === 'right'){
              this.agregarTooltipLeyenda(chartContext);
            }
          }
        }
      },
      labels: this.labelsGRafica,
      colors: this.colors,
      grid: {
        show: this.type==='radar'?false:true,
        padding: {
          bottom: this.type === typesApex.RADAR ? -10 : 10,
          right: this.type === typesApex.HEATMAP || this.type === typesApex.RADAR ? 0 : 30,
          left: this.type === typesApex.RADAR ? -10 : paddingleft,
          top: this.type === typesApex.RADAR ? -10 : 0,
        }
      },
      markers: {
        size: 6,
        hover: {
          size: 6
        },
        fillOpacity: 1,
      },
      legend: {
        show: this.legend.enabled,
        position: this.legend.position,
        offsetX: -30,
        itemMargin: {
          horizontal: 10,
          vertical: 0
        },
        formatter: (seriesName) => this.legend.position === 'right' && seriesName.length > 22 ? seriesName.substring(0, 22) + '...' : seriesName
      },
      theme: {
        monochrome: {
          enabled: (this.type !== typesApex.PIE && this.type !== typesApex.DONUT) ? false : this.distributed,
          color: this.colors[0]
        }
      },
      dataLabels: {
        enabled: this.etiquetas,
        formatter: ( val, opts) => {
          if(!this.formatEtiquetas){
            if(this.type === typesApex.PIE || this.type === typesApex.DONUT){
              // val es el % que calcula ApexCharts; el monto real hay que sacarlo de la serie.
              const valor = this.porcentaje
                ? `${val.toFixed(1)}%`
                : this.formatearMontoAbreviado(opts.w.globals.series[opts.seriesIndex]);
              // Sin leyenda no hay otro lugar donde ver el nombre: la etiqueta lo lleva siempre
              return this.legend.enabled ? [valor] : [valor, `${opts.w.config.labels[opts.seriesIndex]}`];
            }else if(this.type === typesApex.HEATMAP){
              // La etiqueta siempre va, entre corchetes y más chica (ver reducirNombreHeatmap).
              // Se quita " años" de los rangos de edad.
              const nombreCuenta = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].x;
              const etiqueta = `[${`${nombreCuenta}`.replace(' años', '')}]`;
              if(this.porcentaje){
                const serieValores: number[] = opts.w.globals.series[opts.seriesIndex] ?? [];
                const tot = Number(serieValores.reduce((a, b) => a + Number(b), 0).toFixed(1));
                const valNum = Number(opts.value);
                const por = (valNum===0 || !tot || isNaN(tot))?0:Number((valNum*100/tot).toFixed(1));
                return [`${por}%`, etiqueta];
              }
              if(this.hetamapValor){
                return [`${opts.value}`];
              }
              // opts.value (no val) trae el dato real, igual que en porcentaje/hetamapValor.
              return [this.formatearMontoAbreviado(opts.value), etiqueta];
            }else if(this.type === typesApex.STACKED){
              return [`${val.toFixed(1)} %`];
            }else if(this.type === typesApex.RADAR){
              return `${val}`
            }else if(opts){
              const tot = Number(opts.w.config.series[opts.seriesIndex].data.reduce((a, b) => a + b, 0).toFixed(1));
              const por = (val===0 || tot===0)?0:Number((val*100/tot).toFixed(1))
              return [`${por} %`];
            }            
          }
          if(this.formatEtiquetas){
            // ApexCharts sigue llamando este formatter con val=undefined para series
            // ocultas desde la leyenda; sin este guard, tronaba y dejaba la gráfica
            // en un estado roto (afectando también a las demás series).
            if(val == null){
              return [''];
            }
            if(this.comboLineaPorcentaje){
              if(opts.seriesIndex === 0){
                return [`${val.toFixed(1)} %`];
              }
              return [this.formatearMontoAbreviado(val)];
            }
            if(val > 100){
              return formatear.formatearMoneda(val,false,',','.');
            }else{
              if(this.type === typesApex.STACKED || this.type === typesApex.STACKEDHORIZONTAL){
                return [`${val.toFixed(2)} %`];
              }
              return formatear.formatearMoneda(Number((val).toFixed(2)),true,',','.');
            }

          }
          return [''];
        },
        textAnchor: this.type !== typesApex.STACKED && this.type !== typesApex.STACKEDHORIZONTAL ? 'start': 'middle',
        position: 'center',
        offsetX: 0,
        offsetY: this.type !== typesApex.STACKEDHORIZONTAL ? -5 : 0,
        style:{
          fontWeight: this.type === typesApex.HEATMAP && !this.porcentaje ? 500 : 400,
          fontFamily: 'Roboto',
          fontSize: this.type === typesApex.HEATMAP ? '20px' : '11px',
          colors: this.type === typesApex.HEATMAP ? ['#000000'] : []
        },
        dropShadow: {
          enabled: false,
        },
        background: {
          enabled: true,
          foreColor: '#000000',
          padding: 4,
          borderRadius: 2,
          borderWidth: 1,
          borderColor: '#000000',
          opacity: 0,
          dropShadow: {
            enabled: false,
          }
        },
      },
      stroke: {
        show: this.type !== typesApex.DONUT ? true : false,
        curve: 'smooth',
      },
      xaxis: {
        max: undefined,
        min: undefined,
        categories: this.labelsGRafica,
        tickAmount: this.esBarraHorizontal ? 5 : undefined,
        labels: {
          maxHeight: 400,
          maxWidth: 500,
          rotate: -90,
          trim: this.esBarraHorizontal?false:true,
          style: {
            fontSize: '7px',
          },
        },
        tooltip:{
          enabled: false,
          theme: "dark"
        },
        title:{
          text: this.axisX,
          offsetY: 0,
          style:{fontWeight: 400, fontSize: '13px'}
        }
      },
      // Mapa de calor con una sola serie no pasa por setEjes(); sin esto, ApexCharts
      // reserva espacio para un eje Y aunque esté vacío y el mapa queda descentrado.
      yaxis: this.type === typesApex.HEATMAP ? { show: false } : {},
      tooltip: {
        enabled: true,
        shared: false,
        intersect: true,
         // Cambiar formato del valor
        y: {
          formatter: (val) => {
            if(val > 100){
              return formatear.formatearMoneda(val,false,',','.');
            }else{
              return formatear.formatearMoneda(Number((val).toFixed(2)),true,',','.');
            }            
          },
        },
      }
    };
    this.plotOptions(funnel);
    this.setEjes(dataFormat);
    this.setLabels();
    this.setLabelsEjes();
    this.setStroke();
    this.setAnotaciones();
    this.setCascada();
    this.setApiladaPorcentaje();
    this.setBurbujas();

    setTimeout(() =>{
        this.chart = new ApexCharts(
          document.querySelector(`#grafica${this.zona}`),
          this.options
        );
        this.chartAmp = new ApexCharts(
          document.querySelector(`#graficaExportB${this.zona}`),
          this.options_export
        );
        this.chartAmp.render();
        this.chartAmp.destroy();
        this.chart.render();
    }, 100);
  }
  /** Monto abreviado con sufijo M/Mil, usado en las etiquetas de combinada (comboLineaPorcentaje). */
  private formatearMontoAbreviado(val: number){
    if(val == null || isNaN(val)){ return ''; }
    // De mil a menos de un millón se muestra el monto completo, sin «Mil»
    if(Math.abs(val) >= 1000 && Math.abs(val) < 1000000){
      return formatear.formatearMoneda(Math.round(val), false, ',', '.');
    }
    let valAbrev = val, sufijo = '';
    if(Math.abs(val) >= 1000000){
      valAbrev = val/1000000;
      sufijo = ' M';
    }else if(Math.abs(val) >= 1000){
      valAbrev = val/1000;
      sufijo = ' Mil';
    }
    return formatear.formatearMoneda(Number(valAbrev.toFixed(2)),true,',','.')+sufijo;
  }
  /* formateo de gráficas */
  private formatData(){
    var dataFormat;
    switch(this.type){
      case typesApex.HEATMAP:
        dataFormat = this.data.map( d => {
          return {
            data: d.data.map( (elem, index) => {
              return {
                x: this.labels[index],
                y: elem
              }
            })
          }
        });
      break;
      case typesApex.DONUT:
      case typesApex.PIE:
        dataFormat = this.data[0].data;
      break;
      case typesApex.COMBO:
      case typesApex.COMBO2:
        dataFormat = this.data.map( (d, i) => {
          return {...d, type: i===0?'line':'bar'}
        });
      break;
      default:
        dataFormat = JSON.parse(JSON.stringify(this.data));
      break;
    }
    return dataFormat;
  }
  /**
   * Tipos que se dibujan con las barras acostadas: el eje de valores es X y el
   * de categorías es Y. El embudo entra aquí porque plotOptions le pone
   * horizontal: true igual que a la barra horizontal.
   */
  private get esBarraHorizontal(): boolean {
    return this.type === typesApex.BARHORIZONTAL || this.type === typesApex.FUNNEL;
  }

  private caracteristicas(){
    var typeGraph = '', stacked = false, funnel = false;
    switch(this.type){
      case typesApex.COMBO:
      case typesApex.COMBO2:
        typeGraph = typesApex.BAR;
      break;
      case typesApex.STACKED:
        typeGraph = typesApex.BAR;
        stacked = true;
      break;
      case typesApex.FUNNEL:
      case typesApex.BARHORIZONTAL:
        typeGraph = typesApex.BAR;
        funnel = true;
      break;
      case typesApex.STACKEDHORIZONTAL:
        typeGraph = typesApex.BAR;
        funnel = true;
        stacked = true;
        break;
      case typesApex.WATERFALL:
        typeGraph = 'rangeBar';
        break;
      default:
        typeGraph = this.type;
      break;
    }

    return {typeGraph, stacked, funnel}
  }
  private plotOptions(funnel){
    switch(this.type){
      case typesApex.RADAR:
        this.options['plotOptions'] = {
          radar: {
            size: this.sizeRadar,
            offsetX: 0,
            offsetY: 0,
            polygons: {
              strokeColors: '#e9e9e9',
              fill: '#f8f8f8'
            }
          }
        }
        this.options_export['plotOptions'] = {
          radar: {
            offsetX: 0,
            offsetY: 0,
            polygons: {
              strokeColors: '#e9e9e9',
              fill: '#f8f8f8'
            }
          }
        }
      break;
      case typesApex.DONUT:
        this.options['plotOptions'] = {
          pie: {
            donut: {
              size: '50%'
            }
          }
        }
        this.options_export['plotOptions'] = {
          pie: {
            donut: {
              size: '50%'
            }
          }
        }
      break;
      case typesApex.HEATMAP:
        // OJO: typesApex.HEATMAP vale 'treemap', así que la llave tiene que ser
        // treemap. Con `heatmap` ApexCharts ignora el bloque y pinta todo igual.
        // enableShades off: si no, degrada un mismo color en vez de usar la paleta.
        this.options['plotOptions'] = {
          treemap: {
            distributed: this.distributed,
            // Con paleta propia hay que apagar el degradado. Sin ella se deja
            // puesto: los tableros que pasan un color único lo quieren sombreado
            // por valor, que es el comportamiento por omisión de ApexCharts.
            enableShades: !this.distributed,
          }
        }
        this.options_export['plotOptions'] = {
          treemap: {
            distributed: this.distributed,
            // Con paleta propia hay que apagar el degradado. Sin ella se deja
            // puesto: los tableros que pasan un color único lo quieren sombreado
            // por valor, que es el comportamiento por omisión de ApexCharts.
            enableShades: !this.distributed,
          }
        }
      break;
      case typesApex.BAR:
      case typesApex.COMBO:
      case typesApex.COMBO2:
      case typesApex.FUNNEL:
      case typesApex.BARHORIZONTAL:
      case typesApex.STACKEDHORIZONTAL:
        var colors: any = { ranges: []};
        if(this.rangoColores.length !== 0){
          for(const col of this.rangoColores){
            colors.ranges.push(col);
          }  
        }
        
        this.options['plotOptions'] = {
          bar: {
            isFunnel : this.type === typesApex.FUNNEL?funnel:false,
            barHeight: funnel?"80%":undefined,
            horizontal: funnel?true:undefined,
            distributed: this.distributed,
            dataLabels: {
              position: this.type === typesApex.FUNNEL || this.type === typesApex.STACKEDHORIZONTAL?"center":"top" // top, center, bottom
            },
            colors 
          }
        }
        this.options_export['plotOptions'] = {
          bar: {
            isFunnel : this.type === typesApex.FUNNEL?funnel:false,
            barHeight: funnel?"80%":undefined,
            horizontal: funnel?true:undefined,
            distributed: this.distributed,
            dataLabels: {
              position: this.type === typesApex.FUNNEL || this.type === typesApex.STACKEDHORIZONTAL?"center":"top" // top, center, bottom
            },
            colors
          }
        }
      break;
    }
  }
  //configuracion de ejes verticales 
  private setEjes(dataFormat){    
    if(!dataFormat || dataFormat.length === 0){
      return;
    }

    // Validar que cada elemento tenga la propiedad 'data'
    const dataValida = dataFormat.every(dat => dat && dat.data && Array.isArray(dat.data));
    if(!dataValida){
      console.warn('Formato de datos inválido en setEjes(graficadorcomponent)');
      return;
    }

    if(this.type !== typesApex.STACKED && this.type !== typesApex.STACKEDHORIZONTAL && this.type !== typesApex.RADAR){
      this.changeLabels()
      var axisY = [];
      var stroke = [];
      var max, min;
      const ejePorcentaje = this.porcentaje && (this.type === typesApex.BAR || this.type === typesApex.LINE || this.type === typesApex.AREA);
      this.axisY.forEach( (eje, i) =>{
        const total = dataFormat[i].data.reduce((suma, dato) => suma + Number(dato), 0);
        // En combinadas con línea en %, el primer eje es el del porcentaje
        const ejeEnPorcentaje = this.comboLineaPorcentaje && i === 0;
        if(this.type !== typesApex.DONUT){
          max = Math.max(... dataFormat[i].data) * 1.05;
          min = Math.min(... dataFormat[i].data) * 0.95;
          if(this.axisY.length !== dataFormat.length && !this.setTwoLast){
            const max_s = dataFormat.map( d => Math.max(...d.data) );
            const min_s = dataFormat.map( d => Math.min(...d.data) );
            max = Math.max(...max_s) *1.05;
            min = Math.min(...min_s) *0.95;
          }else if(this.axisY.length !== dataFormat.length && this.setTwoLast){
            if(i===0){
              max = Math.max(... dataFormat[0].data) * 1.05;
              min = Math.min(... dataFormat[0].data) * 0.95;
            }else{
              const validData = dataFormat.slice(1);
              const max_s = validData.map(d => Math.max(...d.data));
              const min_s = validData.map(d => Math.min(...d.data));

              max = Math.max(...max_s) * 1.05;
              min = Math.min(...min_s) * 0.95;
            }
          }
          // Asegura que la línea de referencia quede dentro del rango visible
          if(this.lineaReferencia != null){
            max = Math.max(max, this.lineaReferencia * 1.05);
            min = Math.min(min, this.lineaReferencia * 0.95);
          }
        }
        let opposite = false;
        // if (this.type === typesApex.COMBO || this.type === typesApex.COMBO2) {
          if (this.axisY.length > 1) {
            opposite = axisY.length === 0;
          }
        // } else {
        //   opposite = axisY.length > 0;
        // }
        axisY.push({
          max: max,
          min: min,
          opposite: opposite,
          // Ata este eje a la serie por NOMBRE, no por posición: si el usuario oculta una
          // serie desde la leyenda, ApexCharts reacomoda los ejes visibles y la asignación
          // por índice se corre. Con seriesName la asignación no depende de cuántas series
          // sigan visibles.
          seriesName: dataFormat[i]?.name,
          axisTicks: {
            show: true
          },
          axisBorder: {
            show: true,
          },
          title: {
            text: eje,
            // Título del eje ligero (sin negrita) para todas las gráficas. Sin offsetX: ApexCharts ya lo
            // coloca pegado al borde del gráfico y un desplazamiento hacia afuera lo recorta.
            style: { fontWeight: 400, fontSize: '13px' },
          },
          tooltip: {
            enabled: false
          },
          labels: {
            align: (this.type === typesApex.BARHORIZONTAL || this.type === typesApex.STACKEDHORIZONTAL) && this.alinearYIzquierda 
              ? 'left': undefined,
            formatter: (val) => {
              if(ejePorcentaje){
                return `${total === 0 ? 0 : Number((val * 100 / total).toFixed(1))}%`;
              }
              // De mil a menos de un millón se muestra el monto completo, sin «Mil»
              if(!ejeEnPorcentaje && Math.abs(val) >= 1000 && Math.abs(val) < 1000000){
                return `${formatear.formatearMoneda(Math.round(val), false, ',', '.')} -`;
              }
              if(val > 100){
                return formatear.retornarformatolefty(val.toFixed(1));
              }else if(!this.esBarraHorizontal ) {
                return formatear.formatearMoneda(Number((val.toFixed(1))),true,',','.');
              }else{
                // Acostadas, el eje Y son las categorías: llega texto, no número
                return val
              }
            },
            style: {
              fontSize: '12px',
              fontWeight: 400,
            },
          },
          tickAmount: 5
        });
        // El embudo dibuja su propio contorno: un stroke encima le saca picos
        stroke.push(this.type === typesApex.FUNNEL ? 0 : 1);
      });

      // setTwoLast con más series que ejes (ej. 3 series, 2 ejes): ApexCharts necesita
      // un yaxis por serie o las series sin eje propio quedan mal posicionadas/escaladas.
      // Se duplica el último eje (el compartido) una vez por serie extra, oculto
      // visualmente, para que internamente cada serie tenga su eje asignado.
      if(this.setTwoLast && dataFormat.length > axisY.length && axisY.length > 0){
        const ejeCompartido = axisY[axisY.length - 1];
        const strokeCompartido = stroke[stroke.length - 1];
        const primerIndiceFaltante = axisY.length;
        const ejesFaltantes = dataFormat.length - axisY.length;
        for(let k = 0; k < ejesFaltantes; k++){
          axisY.push({
            ...ejeCompartido,
            title: { text: '' },
            labels: { ...ejeCompartido.labels, show: false },
            axisTicks: { show: false },
            axisBorder: { show: false },
            // Igual que arriba: se ata por nombre a la serie que le corresponde a este eje
            // duplicado, para que ocultarla desde la leyenda no le corra la asignación.
            seriesName: dataFormat[primerIndiceFaltante + k]?.name,
          });
          stroke.push(strokeCompartido);
        }
      }

      this.options['stroke']['width'] = axisY.length === 1 ? stroke[0]:stroke;
      this.options_export['stroke']['width'] = stroke;
      if (this.esBarraHorizontal) {
        // El embudo arranca en 0 o el estrechamiento no es proporcional al dato
        const minEjeValores = this.type === typesApex.FUNNEL ? 0 : min;
        this.options['xaxis'].min = minEjeValores;
        this.options['xaxis'].max = max;
        if (this.type === typesApex.FUNNEL) {
          // En el embudo las bandas se estrechan y no se alinean con el eje:
          // las categorías se identifican por leyenda, no por eje.
          axisY.forEach(eje => { eje.labels.show = false; eje.axisTicks.show = false; });
        }
        this.options['yaxis'] = axisY.length === 1 ? axisY[0] : axisY;
        this.options_export['xaxis'].min = minEjeValores;
        this.options_export['xaxis'].max = max;
        this.options_export['yaxis'] = axisY;
      } else {
        this.options['yaxis'] = axisY.length === 1 ? axisY[0] : axisY;
        this.options_export['yaxis'] = axisY;
      }
    }
    if(this.esBarraHorizontal){
      this.options['xaxis']['labels'] = {
        maxWidth: 400,
        formatter: (val) => this.formatearEjeXHorizontal(val),
        style: {
          fontSize: '12px',
          fontWeight: 400,
        },
        trim: true
      }
      this.options_export['xaxis']['labels'] = {
        maxWidth: 400,
        formatter: (val) => this.formatearEjeXHorizontal(val),
        style: {
          fontSize: '12px',
          fontWeight: 400,
        },
      }
    }
    if(this.type === typesApex.STACKED || this.type === typesApex.STACKEDHORIZONTAL){
      this.options['yaxis'] = {
        title:{
          text: this.axisY[0],
        }
      }
      this.options_export['yaxis'] = {
        title:{
          text: this.axisY[0],
        }
      }
    }
  }
  /* Eventos click */
  public clickSeries(event){
    this.eventClick.emit(event);
  }
  // con la leyenda a la derecha (donde se corta el texto largo), muestra el nombre completo (title nativo) al pasar el mouse
  private agregarTooltipLeyenda(chartContext){
    const items = chartContext.el.querySelectorAll('.apexcharts-legend-series');
    items.forEach((item: HTMLElement, i: number) => {
      const nombreCompleto = this.labelsGRafica[i];
      if(nombreCompleto){
        item.setAttribute('title', nombreCompleto);
      }
    });
  }
  //confifuracion de las etiquetas 
  private setLabels(){
    switch(this.type){
      case typesApex.RADAR:
        this.options.dataLabels.enabled = this.etiquetas;
        this.options.dataLabels.position = "top",
        this.options.dataLabels.offsetY = -10,
        this.options.dataLabels.style = {
          fontSize: "14px",
          colors: ["#304758"]
        }
        this.options.dataLabels.background = {
          enabled: true,
          foreColor: '#FFFFFF',
          borderRadius: 4,
          borderWidth: 1,
          borderColor: '#000000',
          opacity: 0.5,
          padding: 4
        }
        this.options.yaxis = {
          labels: {
            show: false
          }
        };
        this.options_export.dataLabels.enabled = this.etiquetas;
        this.options_export.dataLabels.position = "top",
        this.options_export.dataLabels.offsetY = -10,
        this.options_export.dataLabels.style = {
          fontSize: "14px",
          colors: ["#304758"]
        }
        this.options_export.dataLabels.background = {
          enabled: true,
          foreColor: '#FFFFFF',
          borderRadius: 4,
          borderWidth: 1,
          borderColor: '#000000',
          opacity: 0.5,
          padding: 4
        }
        this.options_export.yaxis = {
          labels: {
            show: false
          }
        };
        break;
      case typesApex.HEATMAP:
        // La etiqueta del mapa de calor siempre va más chica que el valor
        this.options.chart.events.mounted = this.reducirNombreHeatmap;
        this.options.chart.events.updated = this.reducirNombreHeatmap;
        this.options_export.chart.events.mounted = this.reducirNombreHeatmap;
        this.options_export.chart.events.updated = this.reducirNombreHeatmap;
        break;
      case typesApex.BARHORIZONTAL:
        this.options.dataLabels.offsetY = 0;
        this.options.dataLabels.offsetX = 8;
        this.options_export.dataLabels.offsetY = 0;
        this.options_export.dataLabels.offsetX = 8;
        break;
      case typesApex.FUNNEL:
        // La etiqueta va dentro de la banda: centrada y sin desplazamientos
        this.options.dataLabels.offsetY = 0;
        this.options.dataLabels.offsetX = 0;
        this.options.dataLabels.textAnchor = 'middle';
        this.options_export.dataLabels.offsetY = 0;
        this.options_export.dataLabels.offsetX = 0;
        this.options_export.dataLabels.textAnchor = 'middle';
        break;
      case typesApex.BAR:
        if(this.formatData){
          this.options.dataLabels.formatter = this.porcentaje
            ? (val, opts) => {
                const tot = Number(opts.w.config.series[opts.seriesIndex].data.reduce((a, b) => a + b, 0).toFixed(1));
                const por = (val===0 || tot===0)?0:Number((val*100/tot).toFixed(1));
                return `${por}%`;
              }
            : function(val: number){
                var dec = false;
                if(val < 10){
                  dec = true;
                }
                return formatear.formatearMoneda(Number(val.toFixed(2)),dec,',','.');
              }
          this.options.chart.events = {
            dataPointSelection: (event, chartContext, opts) => {
              var value;
              if(this.type === typesApex.HEATMAP){
                value = chartContext.opts.series[opts.seriesIndex].data[opts.dataPointIndex].y;
              }else if(this.type === typesApex.PIE || this.type === typesApex.DONUT){
                value = chartContext.opts.series[opts.dataPointIndex];
              }else{
                value = chartContext.opts.series[opts.seriesIndex].data[opts.dataPointIndex];
              }
              var data = {
                name: chartContext.opts.xaxis.categories[opts.dataPointIndex],
                value: value,
                serie: opts.seriesIndex,
                posValue: opts.dataPointIndex,
              }
              this.clickSeries(data)
            },
            mounted: (chartContext) => {
              const labels = chartContext.el.querySelectorAll('.apexcharts-datalabel');
              labels.forEach((lbl: SVGTextElement) => {
                const x = lbl.getAttribute('x') || '0';
                const y = lbl.getAttribute('y') || '0';
                lbl.setAttribute('transform', `rotate(-40 ${x} ${y})`);
              });
            },
            updated: (chartContext) => {
              const labels = chartContext.el.querySelectorAll('.apexcharts-datalabel');
              labels.forEach((lbl: SVGTextElement) => {
                const x = lbl.getAttribute('x') || '0';
                const y = lbl.getAttribute('y') || '0';
                lbl.setAttribute('transform', `rotate(-40 ${x} ${y})`);
              });
            }
          }
          this.options.dataLabels.offsetY = -15;
          this.options.dataLabels.offsetX = 0;
          this.options_export.dataLabels.formatter = this.porcentaje
            ? (val, opts) => {
                const tot = Number(opts.w.config.series[opts.seriesIndex].data.reduce((a, b) => a + b, 0).toFixed(1));
                const por = (val===0 || tot===0)?0:Number((val*100/tot).toFixed(1));
                return `${por}%`;
              }
            : function(val: number){
                var dec = val < 10;
                return formatear.formatearMoneda(Number(val.toFixed(2)),dec,',','.');
              }
          this.options_export.chart.events = {
            dataPointSelection: (event, chartContext, opts) => {
              var value;
              if(this.type === typesApex.HEATMAP){
                value = chartContext.opts.series[opts.seriesIndex].data[opts.dataPointIndex].y;
              }else if(this.type === typesApex.PIE || this.type === typesApex.DONUT){
                value = chartContext.opts.series[opts.dataPointIndex];
              }else{
                value = chartContext.opts.series[opts.seriesIndex].data[opts.dataPointIndex];
              }
              var data = {
                name: chartContext.opts.xaxis.categories[opts.dataPointIndex],
                value: value,
                serie: opts.seriesIndex,
                posValue: opts.dataPointIndex,
              }
              this.clickSeries(data)
            },
            mounted: (chartContext) => {
              const labels = chartContext.el.querySelectorAll('.apexcharts-datalabel');
              labels.forEach((lbl: SVGTextElement) => {
                const x = lbl.getAttribute('x') || '0';
                const y = lbl.getAttribute('y') || '0';
                lbl.setAttribute('transform', `rotate(-40 ${x} ${y})`);
              });
            },
            updated: (chartContext) => {
              const labels = chartContext.el.querySelectorAll('.apexcharts-datalabel');
              labels.forEach((lbl: SVGTextElement) => {
                const x = lbl.getAttribute('x') || '0';
                const y = lbl.getAttribute('y') || '0';
                lbl.setAttribute('transform', `rotate(-40 ${x} ${y})`);
              });
            }
          }
          this.options_export.dataLabels.offsetY = -15;
          this.options_export.dataLabels.offsetX = 0;
          break;
        }
        this.options.dataLabels.offsetY = -20;
        this.options.dataLabels.offsetX = -10;
        this.options_export.dataLabels.offsetY = -20;
        this.options_export.dataLabels.offsetX = -10;
        break;   
      case typesApex.LINE:
      case typesApex.AREA:
        // Antes se recorría -10px para que el texto no se cortara con el overflow del contenedor;
        // ese overflow ya no está, así que en 0 la etiqueta queda pegada a su punto (sin invadir el eje Y).
        this.options.dataLabels.offsetX = 0;
        this.options_export.dataLabels.offsetX = 0;
        this.options.dataLabels.offsetY = -2;
        this.options_export.dataLabels.offsetY = -2;
        break;
    }
  }
  private reducirNombreHeatmap = (chartContext) => {
    chartContext.el.querySelectorAll('.apexcharts-datalabel').forEach((texto: SVGTextElement) => {
      const nombre = texto.querySelectorAll('tspan')[1];
      nombre?.setAttribute('font-size', `${parseFloat(texto.getAttribute('font-size')) * 0.7}`);
    });
  }
  //Activa o desactiva etiquetas
  public onOffLabels(){
    if(this.type === typesApex.WATERFALL || this.type === typesApex.BUBBLE){
      // Las etiquetas de la cascada son anotaciones: se arman de nuevo en vez de prender dataLabels
      this.optionsGraphic();
      return;
    }
    this.options.dataLabels.enabled = this.etiquetas;
    this.options_export.dataLabels.enabled = this.etiquetas;
    this.setLabels();    
    this.chart.destroy();
    setTimeout(() =>{  
      this.chart = new ApexCharts(
        document.querySelector(`#grafica${this.zona}`),//id del div 
        this.options
      );
      this.chart.render();
    }, 100);
  }
  public changeLabels(add?: string){
    if(add){
      this.showLabel+1<this.data.length?this.showLabel++:this.showLabel=0;
    }
    if(this.etiquetas){
      if(this.type === typesApex.COMBO || this.type === typesApex.COMBO2){ //TODO: || this.type === typesApex.LINE si en algun punto se pide que solo aparezca una etiqueta por serie agregar las lineales
        if(this.comboLineaPorcentaje){
          const todasLasSeries = this.data.map((d, i) => i);
          this.options.dataLabels.enabledOnSeries = todasLasSeries;
          this.options_export.dataLabels.enabledOnSeries = todasLasSeries;
        }else{
          this.options.dataLabels.enabledOnSeries = [this.showLabel];
          this.options_export.dataLabels.enabledOnSeries = [this.showLabel];
        }
      }
      if(this.options.series[this.showLabel].type === typesApex.BAR){
        this.options.dataLabels.offsetY = -30;
        this.options_export.dataLabels.offsetY = -30;
      }else{
        this.options.dataLabels.offsetY = -7;
        this.options_export.dataLabels.offsetY = -7;
      }
    }
    if(add){
      this.chart.destroy();
      setTimeout(() =>{  
        this.chart = new ApexCharts(
          document.querySelector(`#grafica${this.zona}`),//id del div 
          this.options
        );
        this.chart.render();
      }, 100);
    }
  }
  public openModal(){
    document.getElementById("ampliar"+this.zona)!.style.display = "block";
    if(this.type !== this.types.TABLE){
      setTimeout(() =>{
        this.chartAmp = new ApexCharts(
          document.querySelector(`#graficaModal${this.zona}`),
          this.options
        );
        this.chartAmp.render();
      }, 100);
    }
  }
  public closeModal(){
    document.getElementById("ampliar"+this.zona)!.style.display = "none";
    if(this.type !== this.types.TABLE){
      this.chartAmp.destroy()
    }
  }
  public clickFuera(event){
    if (event.target === document.getElementById("ampliar"+this.zona)) {
      this.closeModal();
    }
  }
  public changeFontSize(){
    this.chartAmp = new ApexCharts(
      document.querySelector(`#graficaExport${this.zona}`),
      this.options_export
    );
    this.options_export.chart.animations.speed = 10;
    this.options_export.dataLabels.style.fontSize = '20px';
    this.options_export.xaxis.labels.style.fontSize = '22px';
    this.options_export.legend.fontSize = '21px';
    for(const y of this.options_export.yaxis){
      y.labels.style.fontSize = '22px';
      y.title.style.fontSize = '24px';
    }
    this.chart.destroy();
    setTimeout(() =>{  
      this.chart = new ApexCharts(
        document.querySelector(`#grafica${this.zona}`),//id del div 
        this.options_export
      );
      this.chart.render();
    }, 100);
  }
  private setLabelsEjes(){    
    if(this.type === typesApex.BAR && this.data[0]['data'].length > 30){
      this.options.xaxis.labels.style.fontSize = '10px';
      this.options.dataLabels.style.fontSize = '10px';
      this.options_export.xaxis.labels.style.fontSize = '10px';
      this.options_export.dataLabels.style.fontSize = '10px';
    }
    if(this.type === typesApex.BARHORIZONTAL && this.data[0]['data'].length > 30){
      if(this.options.yaxis.length > 1){
        for(const y of this.options.yaxis){
          y.labels.style.fontSize = '8px';
        }
        // TODO si algo falla en las graficas revisar como solucionar esto sin que se muera mayores deudores
        // for(const y of this.options_export.yaxis){
        //   y.labels.style.fontSize = '8px';
        // }
      }else{        
        this.options.yaxis.labels.style.fontSize = '8px';
        // this.options_export.yaxis.labels.style.fontSize = '8px';
      }
      this.options.dataLabels.style.fontSize = '8px';
      // this.options_export.dataLabels.style.fontSize = '8px';
    }
  }

  private setStroke(){
    if(this.stroke){
      this.options['stroke'] = {
        dashArray: [8,0,0,0,0],
        width: [3,3,3,3,3]
      }
      this.options_export['stroke'] = {
        dashArray: [8,0,0,0,0],
        width: [3,3,3,3,3]
      }
      if(this.type == this.types.BAR){
        this.options['fill'] = {
          opacity: [0,1,1,1,1]
        }
        this.options_export['fill'] = {
          opacity: [0,1,1,1,1]
        }
      }
    }
  }
  
  /* Línea horizontal de referencia (anotación de eje Y). Solo si se indica un valor. */
  private setAnotaciones(){
    if(this.lineaReferencia == null) return;
    // En barras horizontales el eje de valores es X -> la línea de referencia es vertical.
    const esHorizontal = this.esBarraHorizontal;
    const linea: any = {
      [esHorizontal ? 'x' : 'y']: this.lineaReferencia,
      borderColor: '#616161',
      strokeDashArray: 4,
      label: {
        borderColor: '#616161',
        style: { color: '#fff', background: '#616161', fontSize: '11px', fontFamily: 'Roboto' },
        text: this.lineaReferenciaLabel || '',
        position: esHorizontal ? 'top' : 'left',
        textAnchor: esHorizontal ? 'middle' : 'start',
      }
    };
    const anotacion = esHorizontal ? { xaxis: [linea] } : { yaxis: [linea] };
    this.options['annotations'] = anotacion;
    this.options_export['annotations'] = JSON.parse(JSON.stringify(anotacion));
  }

  /**
   * Apilada en % (STACKED con stackedAbsoluto y porcentaje): los valores ya son % y se apilan tal cual, así que la columna mide la suma
   * (puede pasar de 100%). Cada segmento lleva su % en blanco, sin decimales; encima de cada columna va su total ("Total 87%") y el eje
   * se muestra en % de 20 en 20 (de 10 en 10 si el rango es corto), con margen arriba para que quepa el total.
   */
  private setApiladaPorcentaje(){
    if(this.type !== typesApex.STACKED || !this.stackedAbsoluto || !this.porcentaje || !this.data || this.data.length === 0){
      return;
    }
    const categorias: string[] = this.labelsGRafica;
    const totales = categorias.map((_, i) => this.data.reduce((suma, serie) => suma + (Number(serie.data[i]) || 0), 0));
    const textoTotal = this.translate.instant('graficador.total');
    const puntos = this.etiquetas ? categorias.map((categoria, i) => ({
      x: categoria,
      y: totales[i],
      marker: { size: 0 },
      label: {
        text: `${textoTotal} ${Math.round(totales[i])}%`,
        borderWidth: 0,
        offsetY: -4,
        style: { background: 'transparent', color: '#333333', fontSize: '13px', fontWeight: 700, fontFamily: 'Roboto' },
      },
    })) : [];
    const alto = Math.max(0, ...totales);
    const margen = (alto || 1) * 0.15;
    const salto = alto + margen > 60 ? 20 : 10;
    const maxEje = Math.ceil((alto + margen) / salto) * salto;
    const eje = () => [{
      min: 0,
      max: maxEje,
      tickAmount: Math.round(maxEje / salto),
      axisTicks: { show: true },
      axisBorder: { show: true },
      tooltip: { enabled: false },
      title: { text: this.axisY[0] ?? '', style: { fontWeight: 400, fontSize: '13px', fontFamily: 'Roboto' } },
      labels: { formatter: (valor: number) => `${Math.round(valor)}%`, style: { fontSize: '12px', fontWeight: 400, fontFamily: 'Roboto' } },
    }];
    for(const opciones of [this.options, this.options_export]){
      opciones.dataLabels.enabled = this.etiquetas;
      opciones.dataLabels.formatter = (valor: number) => valor == null ? '' : `${Math.round(valor)}%`;
      opciones.dataLabels.style = { ...opciones.dataLabels.style, fontWeight: 700 };
      opciones.dataLabels.background = { ...opciones.dataLabels.background, foreColor: '#FFFFFF' };
      opciones.tooltip = { ...opciones.tooltip, y: { formatter: (valor: number) => `${Number(valor).toFixed(1)}%` } };
      opciones.yaxis = eje();
    }
    this.options.annotations = { ...(this.options.annotations ?? {}), points: puntos };
    this.options_export.annotations = { ...(this.options_export.annotations ?? {}), points: JSON.parse(JSON.stringify(puntos)) };
  }

  /**
   * Cascada (WATERFALL): una barra flotante por categoría, en tres series (Aumento, Disminución y Total) que se encimen en una sola
   * columna. data[0].data trae el valor de cada paso: las posiciones de cascadaTotales son totales (arrancan de 0 y reinician el
   * acumulado) y el resto son variaciones sobre el acumulado. Las etiquetas son anotaciones sobre la barra (debajo si es un total
   * negativo), en rojo si el valor es negativo. Los colores van en este orden: Total, Aumento, Disminución.
   */
  private setCascada(){
    if(this.type !== typesApex.WATERFALL || !this.data || this.data.length === 0){
      return;
    }
    const valores: number[] = this.data[0].data.map(valor => Number(valor) || 0);
    let acumulado = 0;
    const pasos = valores.map((valor, i) => {
      const esTotal = this.cascadaTotales.includes(i);
      const desde = esTotal ? 0 : acumulado;
      acumulado = esTotal ? valor : acumulado + valor;
      return { nombre: String(this.labelsGRafica[i] ?? ''), esTotal, valor, desde, hasta: acumulado };
    });
    const serieDe = (paso: { esTotal: boolean; valor: number }) => paso.esTotal ? 2 : (paso.valor >= 0 ? 0 : 1);
    const nombresSerie = ['cascada-aumento', 'cascada-disminucion', 'cascada-total'].map(clave => this.translate.instant(`graficador.${clave}`));
    // ApexCharts descarta un rango cuyo extremo es exactamente 0
    const sinCero = (valor: number) => valor === 0 ? 1e-6 : valor;
    const series = nombresSerie.map((name, indice) => ({
      name,
      data: pasos.map(paso => ({
        x: paso.nombre,
        y: serieDe(paso) === indice ? [sinCero(Math.min(paso.desde, paso.hasta)), sinCero(Math.max(paso.desde, paso.hasta))] : null,
      })),
    }));
    const etiqueta = (paso: { esTotal: boolean; valor: number }) => {
      const texto = this.porcentaje ? `${Math.round(paso.valor) || 0}%` : this.formatearMontoAbreviado(paso.valor);
      return `${!paso.esTotal && paso.valor >= 0 ? '+' : ''}${texto}`;
    };
    const puntos = this.etiquetas ? pasos.map(paso => {
      const debajo = paso.esTotal && paso.valor < 0;
      return {
        x: paso.nombre,
        y: debajo ? Math.min(paso.desde, paso.hasta) : Math.max(paso.desde, paso.hasta),
        marker: { size: 0 },
        label: {
          text: etiqueta(paso),
          borderWidth: 0,
          offsetY: debajo ? 24 : -4,
          style: { background: 'transparent', color: paso.valor < 0 ? '#D32F2F' : '#333333', fontSize: '13px', fontWeight: 700, fontFamily: 'Roboto' },
        },
      };
    }) : [];
    // Margen arriba y abajo para que las etiquetas no queden fuera del área de la gráfica
    const extremos = pasos.flatMap(paso => [paso.desde, paso.hasta]);
    const alto = Math.max(0, ...extremos);
    const bajo = Math.min(0, ...extremos);
    const margen = ((alto - bajo) || 1) * 0.15;
    // Nombres en varias líneas (hasta 3, unos 14 caracteres cada una) para que no se encimen entre barras
    const partirNombre = (nombre: string) => {
      const lineas: string[] = [];
      for(const palabra of nombre.split(' ')){
        const ultima = lineas.length - 1;
        if(ultima >= 0 && `${lineas[ultima]} ${palabra}`.length <= 14){
          lineas[ultima] = `${lineas[ultima]} ${palabra}`;
        }else{
          lineas.push(palabra);
        }
      }
      return lineas.length > 3 ? [...lineas.slice(0, 2), `${lineas.slice(2).join(' ').substring(0, 13)}…`] : lineas;
    };
    // En % el eje salta de 20 en 20 (de 10 en 10 si el rango es corto) y arranca y termina en múltiplos del salto
    const limiteInferior = bajo < 0 ? bajo - margen : 0;
    const limiteSuperior = alto + margen;
    const salto = limiteSuperior - limiteInferior > 60 ? 20 : 10;
    const minEje = this.porcentaje ? Math.floor(limiteInferior / salto) * salto : limiteInferior;
    const maxEje = this.porcentaje ? Math.ceil(limiteSuperior / salto) * salto : limiteSuperior;
    const eje = () => [{
      min: minEje,
      max: maxEje,
      forceNiceScale: !this.porcentaje,
      ...(this.porcentaje ? { tickAmount: Math.round((maxEje - minEje) / salto) } : {}),
      axisTicks: { show: true },
      axisBorder: { show: true },
      tooltip: { enabled: false },
      title: { text: this.axisY[0] ?? '', style: { fontWeight: 400, fontSize: '13px', fontFamily: 'Roboto' } },
      labels: {
        formatter: (valor: number) => this.porcentaje ? `${Math.round(valor)}%` : this.formatearMontoAbreviado(valor),
        style: { fontSize: '12px', fontWeight: 400, fontFamily: 'Roboto' },
      },
    }];
    const etiquetasX = (tamano: string) => ({
      rotate: 0,
      trim: false,
      maxHeight: 120,
      maxWidth: 200,
      style: { fontSize: tamano, fontFamily: 'Roboto' },
      formatter: (valor: any) => typeof valor === 'string' ? partirNombre(valor) : valor,
    });
    const plotOptions = () => ({ bar: { horizontal: false, columnWidth: '70%', rangeBarGroupRows: true } });
    const colores = [this.colors[1], this.colors[2], this.colors[0]];

    this.options.series = series;
    this.options.colors = colores;
    this.options.plotOptions = plotOptions();
    this.options.dataLabels.enabled = false;
    this.options.yaxis = eje();
    this.options.xaxis.labels = etiquetasX('12px');
    this.options.tooltip = {
      enabled: true,
      shared: false,
      intersect: true,
      custom: ({ dataPointIndex }: { dataPointIndex: number }) => {
        const paso = pasos[dataPointIndex];
        return paso ? `<div style="padding: 6px 10px;">${paso.nombre}: <b>${etiqueta(paso)}</b></div>` : '';
      },
    };
    this.options.annotations = { ...(this.options.annotations ?? {}), points: puntos };

    this.options_export.series = series;
    this.options_export.colors = colores;
    this.options_export.plotOptions = plotOptions();
    this.options_export.dataLabels.enabled = false;
    this.options_export.yaxis = eje();
    this.options_export.xaxis.labels = etiquetasX('7px');
    this.options_export.annotations = { ...(this.options_export.annotations ?? {}), points: JSON.parse(JSON.stringify(puntos)) };
  }

  /**
   * Burbujas (BUBBLE): cruza dos variables categóricas. `labels` son las categorías del eje X y cada serie de `data` es una categoría
   * del eje Y (su nombre) con un valor por categoría de X; ese valor es el tamaño de la burbuja y también su etiqueta. Un valor
   * vacío o en 0 no dibuja burbuja. ApexCharts solo grafica ejes numéricos, así que las categorías van por posición (0, 1, 2...)
   * y los nombres se ponen desde el formatter de cada eje, con una posición libre a cada lado para que no se corten las burbujas
   * de los extremos. El tamaño se escala entre el valor mínimo y el máximo de la gráfica.
   */
  private setBurbujas(){
    if(this.type !== typesApex.BUBBLE || !this.data || this.data.length === 0){
      return;
    }
    const columnas: string[] = this.labelsGRafica;
    const filas: string[] = this.data.map(serie => String(serie.name ?? ''));
    const todos: number[] = this.data.flatMap(serie => columnas.map((_, x) => Number(serie.data?.[x]))).filter(valor => valor > 0);
    const menor = Math.min(...todos);
    const rango = Math.max(...todos) - menor;
    // ApexCharts calcula el radio con el z tal cual (sin restarle el mínimo), así que valores cercanos entre sí (4.0 a 4.9) salen
    // todos del tamaño máximo. Se manda z normalizado de 0 a 1 y el valor real va aparte en `valor`.
    const series = this.data.map((serie, fila) => ({
      name: String(serie.name ?? ''),
      data: columnas
        .map((_, x) => ({ x, y: fila, valor: Number(serie.data?.[x]) }))
        .filter(punto => punto.valor > 0)
        .map(punto => ({ ...punto, z: rango > 0 ? (punto.valor - menor) / rango : 1 })),
    }));
    const radios = rango > 0 ? { minBubbleRadius: 20, maxBubbleRadius: 38 } : { minBubbleRadius: 30, maxBubbleRadius: 30 };
    const texto = (valor: number) => `${Number(valor.toFixed(2))}${this.porcentaje ? '%' : ''}`;
    const cortar = (nombre: string, largo: number) => nombre.length > largo ? `${nombre.substring(0, largo)}…` : nombre;
    const ejeNombres = (nombres: string[], largo: number, titulo: string, invertido: boolean, tamano: string) => ({
      type: 'numeric',
      min: -1,
      max: nombres.length,
      tickAmount: nombres.length + 1,
      reversed: invertido,
      axisTicks: { show: false },
      axisBorder: { show: true },
      tooltip: { enabled: false },
      title: { text: titulo, style: { fontWeight: 400, fontSize: '13px', fontFamily: 'Roboto' } },
      labels: {
        rotate: 0,
        trim: false,
        maxWidth: 160,
        style: { fontSize: tamano, fontFamily: 'Roboto' },
        formatter: (valor: number) => Number.isInteger(valor) && nombres[valor] != null ? cortar(nombres[valor], largo) : '',
      },
    });
    const aplicar = (opciones: any, tamano: string) => {
      opciones.series = series;
      opciones.colors = this.colors;
      opciones.plotOptions = { bubble: radios };
      opciones.fill = { opacity: 0.8 };
      opciones.grid = { show: true, borderColor: '#E0E0E0' };
      opciones.xaxis = ejeNombres(columnas, 14, this.axisX, false, tamano);
      opciones.yaxis = ejeNombres(filas, 18, this.axisY[0] ?? '', true, tamano);
      opciones.dataLabels = {
        ...opciones.dataLabels,
        enabled: this.etiquetas,
        enabledOnSeries: undefined,
        offsetX: 0,
        offsetY: 0,
        textAnchor: 'middle',
        formatter: (_: any, datos: any) => texto(datos.w.config.series[datos.seriesIndex].data[datos.dataPointIndex].valor),
        style: { fontSize: tamano, fontFamily: 'Roboto', fontWeight: 600, colors: ['#333333'] },
        background: { enabled: false },
      };
      opciones.tooltip = {
        enabled: true,
        shared: false,
        intersect: true,
        custom: ({ seriesIndex, dataPointIndex, w }: any) => {
          const punto = w.config.series[seriesIndex].data[dataPointIndex];
          return `<div style="padding: 6px 10px;">${filas[punto.y]} · ${columnas[punto.x]}: <b>${texto(punto.valor)}</b></div>`;
        },
      };
    };
    aplicar(this.options, '12px');
    aplicar(this.options_export, '8px');
  }

  // Exportar imagen grande
  public async exportImg(zona: number,titulos: Titulos) {
    messages.messageSaving(this.translate.instant('swal.generandoImg'),this.translate.instant('swal.espere'));

    if(this.chartAmp){
      this.chartAmp.destroy();
    }
    
    this.chartAmp = new ApexCharts(
      document.querySelector(`#graficaExport${this.zona}`),
      this.options_export
    );

    this.tituloZona = titulos.titulo;
    this.subTituloZona = titulos.subtitulo;
    this.options_export.chart.animations.speed = 0;
    this.options_export.chart.animations.enabled = false;
    this.options_export.dataLabels.style.fontSize =  '11px';
    this.options_export.xaxis.labels.style.fontSize = '16px';
    this.options_export.xaxis.title.style.fontSize = '18px';
    this.options_export.legend.fontSize = '21px';
    for(const y of this.options_export.yaxis){
      y.labels.style.fontSize = '16px';
      y.title.style.fontSize = '18px';
    }
    if(this.type === typesApex.BAR && this.data[0]['data'].length > 30){
      this.options_export.xaxis.labels.style.fontSize = '12px'
      this.options_export.dataLabels.style.fontSize = '13px';
    }
    if(this.type === typesApex.BARHORIZONTAL && this.data[0]['data'].length > 30){
      for(const y of this.options_export.yaxis){
        y.labels.style.fontSize = '10px';
      }
      this.options_export.dataLabels.style.fontSize = '11px';
    }
    
    this.chartAmp = new ApexCharts(
      document.querySelector(`#graficaExport${this.zona}`),
      this.options_export
    );
    await this.chartAmp.render();
    const result = await this.chartAmp.dataURI();

    if ('imgURI' in result) {
      const a = document.createElement('a');
      a.href = result.imgURI;
      a.download = `${titulos.nombreArch}.png`;
      a.click();
    }

    Swal.close();
    messages.succesMessageGraph(
        this.translate.instant('swal.descargaExi')
    );
  }
  public exportImgBlob() {
    return new Promise(async (resolve) => {
      if(this.chartAmp){
        this.chartAmp.destroy();
      }

      this.options_export.chart.animations.enabled = false;
      this.options_export.dataLabels.style.fontSize =  '11px';
      this.options_export.xaxis.labels.style.fontSize = '16px';
      this.options_export.xaxis.title.style.fontSize = '18px';
      this.options_export.legend.fontSize = '21px';
      var stroke = []
      for(const eje of this.labelsGRafica){
        stroke.push(4)
      }
      if(this.type !== typesApex.DONUT){
        this.options_export['stroke']['width'] = stroke;
      }else{
        this.options_export['stroke']['width'] = 4;
      }
      for(const y of this.options_export.yaxis){
        y.labels.style.fontSize = '16px';
        y.title.style.fontSize = '18px';
      }
      if(this.type === typesApex.BAR && this.data[0]['data'].length > 30){
        this.options_export.xaxis.labels.style.fontSize = '12px'
        this.options_export.dataLabels.style.fontSize = '13px';
      }
      if(this.type === typesApex.BARHORIZONTAL && this.data[0]['data'].length > 30){
        for(const y of this.options_export.yaxis){
          y.labels.style.fontSize = '10px';
        }
        this.options_export.dataLabels.style.fontSize = '11px';
      }
      
      this.chartAmp = new ApexCharts(
        document.querySelector(`#graficaExportB${this.zona}`),
        this.options_export
      );
      this.chartAmp.render();
      setTimeout(async () => {
        const base64 = await this.chartAmp.dataURI();
        const canvas = base64.imgURI;
        const table = {
          widths: ['*'],
          body: [
            [
              {
                image: canvas,
                width: this.ancho,
              }
            ]
          ]
        }
        resolve(
        {
          alignment: 'center',
          table: table,
          width: '100%',
          margin: [0,20,0,20],
          layout: 'noBorders',
        });
      }, 100);
    });
  }
  /**
   * Funcion para la configurar el eje x 
   */
  private formatearEjeXHorizontal(valor: number | string): string {
    const numero = Number(valor);

    if (!Number.isFinite(numero)) {
      return String(valor);
    }

    const signo = numero < 0 ? '-' : '';
    const absoluto = Math.abs(numero);

    if (absoluto >= 1_000_000_000) {
      return `${signo}${Math.round(absoluto / 1_000_000_000)} Mil M`;
    }

    if (absoluto >= 1_000_000) {
      return `${signo}${Math.round(absoluto / 1_000_000)} M`;
    }

    if (absoluto >= 1_000) {
      return `${signo}${Math.round(absoluto / 1_000)} Mil`;
    }

    // Los valores chicos pueden traer decimales significativos (promedios en
    // escala 1-5, por ejemplo): redondear a entero colapsaria ticks distintos
    // en la misma etiqueta y el eje saldria repetido (3, 3, 3, 4, 4, 4).
    if (Number.isInteger(numero)) {
      return `${numero}`;
    }

    return numero.toFixed(2).replace(/\.?0+$/, '');
  }

  private resumirCategoriasHorizontales(data: any[], labels: string[]) {
    // Pie/Donut traen los datos como arreglo plano de números (no series por categoría);
    // se agrupa igual que en barras/lineal, pero con su propio formato.
    if (this.type === typesApex.PIE || this.type === typesApex.DONUT) {
      return this.resumirCategoriasPie(data, labels);
    }
    // Heatmap tampoco usa el formato de series por categoría; agrupar no aplica ahí.
    if (this.type === typesApex.HEATMAP) {
      return { data, labels };
    }

    const limite = Math.max(1, Math.floor(this.maxCategoriasVisibles));

    if (!this.agruparCategoriasExcedentes || labels.length <= limite) {
      return this.ordenarCategorias(data, labels);
    }

    const indicesOrdenados = labels
      .map((_, indice) => indice)
      .sort((a, b) => {
        const totalA = data.reduce((total, serie) => total + Math.abs(Number(serie.data[a]) || 0), 0);
        const totalB = data.reduce((total, serie) => total + Math.abs(Number(serie.data[b]) || 0), 0);
        return totalB - totalA;
      });

    const indicesVisibles = indicesOrdenados.slice(0, limite);
    const indicesOtros = indicesOrdenados.slice(limite);

    const datosResumidos = {
      labels: [
        ...indicesVisibles.map(indice => labels[indice]),
        this.etiquetaOtros
      ],
      data: data.map(serie => ({
        ...serie,
        data: [
          ...indicesVisibles.map(indice => Number(serie.data[indice]) || 0),
          indicesOtros.reduce((suma, indice) => suma + (Number(serie.data[indice]) || 0), 0)
        ]
      }))
    };

    // "Otros" se conserva al final; solo se ordenan las categorías visibles.
    const categoriasVisibles = this.ordenarCategorias(
      datosResumidos.data.map(serie => ({ ...serie, data: serie.data.slice(0, limite) })),
      datosResumidos.labels.slice(0, limite)
    );

    return {
      labels: [...categoriasVisibles.labels, this.etiquetaOtros],
      data: categoriasVisibles.data.map((serie, indice) => ({
        ...serie,
        data: [...serie.data, datosResumidos.data[indice].data[limite]]
      }))
    };
  }

  /** Igual que resumirCategoriasHorizontales, pero para Pie/Donut: data es un arreglo
   * plano de números, no una lista de series con su propio .data. */
  private resumirCategoriasPie(data: number[], labels: string[]) {
    const limite = Math.max(1, Math.floor(this.maxCategoriasVisibles));

    if (!this.agruparCategoriasExcedentes || labels.length <= limite) {
      return { data, labels };
    }

    const indicesOrdenados = labels
      .map((_, indice) => indice)
      .sort((a, b) => Math.abs(Number(data[b]) || 0) - Math.abs(Number(data[a]) || 0));

    const indicesVisibles = indicesOrdenados.slice(0, limite);
    const indicesOtros = indicesOrdenados.slice(limite);

    return {
      labels: [...indicesVisibles.map(indice => labels[indice]), this.etiquetaOtros],
      data: [
        ...indicesVisibles.map(indice => Number(data[indice]) || 0),
        indicesOtros.reduce((suma, indice) => suma + (Number(data[indice]) || 0), 0)
      ]
    };
  }

  private ordenarCategorias(data: any[], labels: string[]) {
    if (this.ordenCategorias === 'original') {
      return { data, labels };
    }

    const indicesOrdenados = labels
      .map((_, indice) => indice)
      .sort((a, b) => {
        const totalA = data.reduce((total, serie) => total + (Number(serie.data[a]) || 0), 0);
        const totalB = data.reduce((total, serie) => total + (Number(serie.data[b]) || 0), 0);
        const diferencia = this.ordenCategorias === 'ascendente' ? totalA - totalB : totalB - totalA;
        return diferencia || a - b;
      });

    return {
      labels: indicesOrdenados.map(indice => labels[indice]),
      data: data.map(serie => ({
        ...serie,
        data: indicesOrdenados.map(indice => serie.data[indice])
      }))
    };
  }
}

